var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  viewBox: "0 0 60 60"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#417EFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28m0 2C13.431 60 0 46.569 0 30S13.431 0 30 0s30 13.431 30 30-13.431 30-30 30"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(28 12)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 32.389,
  r: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.254,
  height: 27.05,
  x: 0.873,
  y: 0.666,
  rx: 1.127
})))));
export default SvgWarning;